<template>

  <div class="head">
    <headr :menuIndex=1></headr>

    <div id="pc">


      <div class="menu">
        <div :style="menuIndex==0?menuYes:menuNo" @click="onclick(0)"><span>安全性</span></div>
        <div :style="menuIndex==1?menuYes:menuNo" @click="onclick(1)"><span>网络诈骗专题</span></div>
        <div :style="menuIndex==2?menuYes:menuNo" @click="onclick(2)"><span>行业相关</span></div>

      </div>

      <div class="pc-menu0" v-show="menuIndex==0">
        <p>海鸥APP采用了哪些安全层级?</p>
        <div>
          <p>4大核心安全层级</p>
          <div>
            <div><span class="pcLable">•</span><span>通道加密</span></div>
            <div><span class="pcLable">•</span><span>内容加密</span></div>
            <div><span class="pcLable">•</span><span>服务器数据库安全</span></div>
            <div><span class="pcLable">•</span><span>密钥安全</span></div>
          </div>

        </div>
        <p>海鸥APP加密方式详细信息</p>

        <div class="jmInfo">

          <div :style="jmInfoIndex==0?jmInfoIndexYes:jmInfoIndexNo" @click="onclickJxInfo(0)"><span>通道加密</span></div>
          <div :style="jmInfoIndex==1?jmInfoIndexYes:jmInfoIndexNo" @click="onclickJxInfo(1)"><span>内容加密详解</span></div>
          <div :style="jmInfoIndex==2?jmInfoIndexYes:jmInfoIndexNo" @click="onclickJxInfo(2)"><span>服务器数据库安全</span>
          </div>
          <div :style="jmInfoIndex==3?jmInfoIndexYes:jmInfoIndexNo" @click="onclickJxInfo(3)"><span>密钥安全</span></div>
        </div>

        <div class="pc-jmInfo0" v-show="jmInfoIndex==0">
          <p>通道加密中采用了哪些加密算法？</p>
          <div>
            <div>
              <p>步骤: </p>
              <p>1. 客户端和服务器先产生随机数 </p>
              <p>2. 服务器下发随机数。</p>
              <p>3. 客户端用 RSA 对客户端随机数进行加密，并发送给服务器。</p>
              <p>4. 服务器用 RSA 解密客户端随机数（使用 RSA 的目的是防止中间人攻击）。</p>
              <p>5. 客户端，服务器用自己的随机数加上对方的随机数生成临时密钥 TempKey 和临时偏移量 TempIV (此时双方均持有相同的 TempKey和TempIV)。</p>
              <p>6. 客户端服务器均使用 ECDHE 生成各自的公私钥对。 </p>
              <p>7. 客户端用 TempKey, TempIV 对自己的 ECDHE 公钥进行加密，并将密文发送给服务器。</p>
              <p>8. 服务器收到客户端的 ECDHE 公钥密文，并解密。</p>
              <p>9. 服务器使用 TempKey, TempIV 对自己的 ECDHE 公钥进行加密，并使用 RSA 对 ECDHE。</p>
              <p>10. 服务器使用 ECDHE 算法，使用客户端 ECDHE 公钥明文+服务器 ECDHE 私钥明文生成ShareKey。</p>
              <p>11. 客户端收到服务器的 ECDHE 公钥密文和签名，然后进行解密和验证签名，如果没有问题，就使用客户端 ECDHE 私钥明文+服务器ECDHE 公钥明文生成 ShareKey。</p>
              <p>12. 服务器初始化各个参数，下发给客户端,参数包含：</p>
              <p>• AuthKeyID： 服务器随机生成的客户端临时标识符 </p>
              <p>• MsgKey： 由 ShareKey, AuthkeyID, MsgID, SessionID, Salt, SeqNo 以及真实的消息内容相加后进行 Sha256 后的值。</p>
              <p>本参数用于：</p>
              <p>a. 进行防止数据篡改的验证 </p>
              <p>b. 与 ShareKey 一起使用，生成 Aes256 key, IV，用来对各条消息进行加密。</p>
              <p>• MsgID：时间相关的消息 ID，用于防止重放和去重。</p>
              <p>• SessionID：每次登录唯一的会话 ID。</p>
              <p>• Salt：每次登录唯一的盐值。</p>
              <p>• SeqNo：用于防止重放。</p>
              <p>13. 后续每条消息均会有不同的 MsgID, SessionID, Salt, SeqNo 和真实的消息内容；这些变化的值会导致 MsgKey 每次都不同。 这个每次都 不同的 MsgKey 加上
                ShareKey 可以为每一条消息生成对应的 32 字节密钥和偏移量。 </p>
              <p>14. ShareKey 会过期，过期后需要重新进行密钥协商。</p>
            </div>
            <div><img src="@/img/pc/td.png" alt=""></div>
          </div>
          <p>什么是公钥和私钥？</p>
          <div>
            <p>公开密钥（PubKey:简称公钥）和私有密钥（PriKey:简称私钥）。公钥与私钥是一对，如果用公钥对数据进行加密，只有用对应的私钥才能解密。
              因为加密和解密使用的是两个不同的密钥，所以这种算法叫作非对称加密算法。如上文加密中使用的RSA、ECDHE为非对称加密算法</p>
          </div>
          <p>非对称加密工作原理？</p>
          <div>
            <p>1、A要向B发送信息，A和B都要产生一对用于加密和解密的公钥和私钥。</p>
            <p>2、A的私钥保密，A的公钥告诉B；B的私钥保密，B的公钥告诉A。</p>
            <p>3、A要给B发送信息时，A用B的公钥加密信息，因为A知道B的公钥。</p>
            <p>4、A将这个消息发给B（已经用B的公钥加密消息）。</p>
            <p>5、B收到这个消息后，B用自己的私钥解密A的消息。其他所有收到这个数据的人都无法解密，因为只有B才有B的私钥。</p>
          </div>
        </div>

        <div class="pc-jmInfo1" v-show="jmInfoIndex==1">
          <div>
            <div>
              <p>海鸥 非对称加密 如下图：</p>
              <div>
                <p>(1). 用户生成 ECDHE 公私钥，保存在本地。</p>
                <p>(2). 将公钥发送到服务器，私钥保存在本地。</p>
                <p>(3). 用户登录，获取所有好友信息的更新，包含每个好友的公钥。</p>
                <p>(4). 发送消息，和接收消息时均采用自己的私钥+对方的公钥生成 ShareKey。</p>
                <p>(5). 使用 ShareKey 生成 AES256 的密钥，进行加密和解密。</p>
              </div><img src="@/img/pc/Frame 1010104364@2x.png" alt="">
            </div>
            <div>
              <p>海鸥 双棘轮算法 如下：</p>
              <div>
                <p>Alice(A)发送的消息传送了她的新公钥。 最终，Bob(B)将收到以下消息之一，并执行第二个DH棘轮步骤； 在每个DH棘轮步骤中生成的DH
                  输出用于导出新的发送和接收链密钥。当各方轮流执行DH棘轮步骤时，他们轮流引入新的发送链，依此类推。</p>
              </div><img src="@/img/pc/Frame 1010104364@2x (1).png" alt="">
            </div>
          </div>
          <p>什么是公钥和私钥？</p>
          <div>
            公开密钥（PubKey:简称公钥）和私有密钥（PriKey:简称私钥）。公钥与私钥是一对，如果用公钥对数据进行加密，只有用对应的私钥才能解密。
            因为加密和解密使用的是两个不同的密钥，所以这种算法叫作非对称加密算法。如上文加密中使用的RSA、ECDHE为非对称加密算法
          </div>
          <p>非对称加密工作原理？</p>
          <div>
            <p>1、A要向B发送信息，A和B都要产生一对用于加密和解密的公钥和私钥。</p>
            <p>2、A的私钥保密，A的公钥告诉B；B的私钥保密，B的公钥告诉A。</p>
            <p>3、A要给B发送信息时，A用B的公钥加密信息，因为A知道B的公钥。</p>
            <p>4、A将这个消息发给B（已经用B的公钥加密消息）。</p>
            <p>5、B收到这个消息后，B用自己的私钥解密A的消息。其他所有收到这个数据的人都无法解密，因为只有B才有B的私钥。</p>
          </div>
        </div>

        <div class="pc-jmInfo2" v-show="jmInfoIndex==2">
          <p>服务器数据库安全</p>

          <div>
            <p>服务器上的数据库做了防止人为篡改的处理</p>
            <p>(1). 数据库有签名字段。</p>
            <p>(2). 服务器上生成 ECDSA 公私钥。</p>
            <p>(3). 服务器代码中对数据库敏感字段，比如：password, userID, friend 等做增删改操作时均通过 ECDSA 生成签名，并更新到签名字段。</p>
            <p>(4). 服务器代码对 password, userID, friend 等数据进行读取，判断等操作时进行 ECDSA验证签名，只有通过验证才能进行后续流程，否则 给客户端报错。</p>
            <p>(5). 服务端程序进行加密和签名保护。</p>
          </div>
          <p>什么是公钥和私钥？</p>
          <div>
            <p>公开密钥（PubKey:简称公钥）和私有密钥（PriKey:简称私钥）。公钥与私钥是一对，如果用公钥对数据进行加密，只有用对应的私钥才能解密。
              因为加密和解密使用的是两个不同的密钥，所以这种算法叫作非对称加密算法。如上文加密中使用的RSA、ECDHE为非对称加密算法</p>
          </div>
          <p>非对称加密工作原理？</p>
          <div>
            <p>1、A要向B发送信息，A和B都要产生一对用于加密和解密的公钥和私钥。</p>
            <p>2、A的私钥保密，A的公钥告诉B；B的私钥保密，B的公钥告诉A。</p>
            <p>3、A要给B发送信息时，A用B的公钥加密信息，因为A知道B的公钥。</p>
            <p>4、A将这个消息发给B（已经用B的公钥加密消息）。</p>
            <p>5、B收到这个消息后，B用自己的私钥解密A的消息。其他所有收到这个数据的人都无法解密，因为只有B才有B的私钥。</p>
          </div>
        </div>

        <div class="pc-jmInfo3" v-show="jmInfoIndex==3">
          <p>密钥安全</p>
          <div>
            <p>(1). 用户的登录密码，二次密码，自动登录密码，均采用 SRP 算法，服务器上不存储用户的密码。</p>
            <p>(2). 用户的加密私钥仅放在用户手机。 </p>
            <p>(3). 用户可随时在客户端上手动更新内容加密的密钥。</p>
          </div>
          <p>什么是公钥和私钥？</p>
          <div>
            <p>公开密钥（PubKey:简称公钥）和私有密钥（PriKey:简称私钥）。公钥与私钥是一对，如果用公钥对数据进行加密，只有用对应的私钥才能解密。
              因为加密和解密使用的是两个不同的密钥，所以这种算法叫作非对称加密算法。如上文加密中使用的RSA、ECDHE为非对称加密算法</p>
          </div>
          <p>非对称加密工作原理？</p>
          <div>
            <p>1、A要向B发送信息，A和B都要产生一对用于加密和解密的公钥和私钥。 </p>
            <p>2、A的私钥保密，A的公钥告诉B；B的私钥保密，B的公钥告诉A。 </p>
            <p>3、A要给B发送信息时，A用B的公钥加密信息，因为A知道B的公钥。 </p>
            <p>4、A将这个消息发给B（已经用B的公钥加密消息）。 </p>
            <p>5、B收到这个消息后，B用自己的私钥解密A的消息。其他所有收到这个数据的人都无法解密，因为只有B才有B的私钥。</p>
          </div>
        </div>


      </div>

      <div class="pc-menu1" v-show="menuIndex==1">

        <div class="pc-menu1-1" v-show="!showDetailZp">

          <div v-for="item in dynamicNewsDataZp" :key="item.id" @click="clickDynamicNewsDataZp(0,item)">
            <p>{{item.title}}</p>
            <div v-html="item.content"></div>
            <p>{{timestampToTime(item.createTime/1000)}} 来源：{{item.subtitle}}</p>
          </div>
        </div>


        <div class="pc-menu1-2" v-show="showDetailZp">
          <p><span @click="clickDynamicNewsDataZp(1,null)" style="cursor: pointer;">网络诈骗专题></span><span
              style="color: #4371FF;">{{detailDataZp.title}}</span></p>
          <p>{{detailDataZp.title}}</p>
          <p>{{timestampToTime(detailDataZp.createTime/1000)}} 来源：{{detailDataZp.subtitle}}</p>
          <div v-html="detailDataZp.content"></div>
        </div>



      </div>


      <div class="pc-menu2" v-show="menuIndex==2">

        <div class="pc-menu2-1" v-show="!showDetailHy">

          <div v-for="item in dynamicNewsDataHy" :key="item.id" @click="clickDynamicNewsDataHy(0,item)">
            <p>{{item.title}}</p>
            <div v-html="item.content"></div>
            <p>{{timestampToTime(item.createTime/1000)}} 来源：{{item.subtitle}}</p>
          </div>
        </div>


        <div class="pc-menu2-2" v-show="showDetailHy">
          <p><span @click="clickDynamicNewsDataHy(1,null)" style="cursor: pointer;">行业相关></span><span
              style="color: #4371FF;">{{detailDataHy.title}}</span></p>
          <p>{{detailDataHy.title}}</p>
          <p>{{timestampToTime(detailDataHy.createTime/1000)}} 来源：{{detailDataHy.subtitle}}</p>
          <div v-html="detailDataHy.content"></div>
        </div>


      </div>


    </div>









    <div id='mobile'>

      <div class="menu">
        <div :style="menuIndex==0?menuYes:menuNo" @click="onclick(0)"><span>安全性</span></div>
        <div :style="menuIndex==1?menuYes:menuNo" @click="onclick(1)"><span>网络诈骗专题</span></div>
        <div :style="menuIndex==2?menuYes:menuNo" @click="onclick(2)"><span>行业相关</span></div>

      </div>




      <div class="pc-menu0" v-show="menuIndex==0">
        <p>海鸥APP采用了哪些安全层级?</p>
        <div>
          <p>4大核心安全层级</p>
          <div>
            <div><span class="pcLable">•</span><span>通道加密</span></div>
            <div><span class="pcLable">•</span><span>内容加密</span></div>
            <div><span class="pcLable">•</span><span>服务器数据库安</span></div>
            <div><span class="pcLable">•</span><span>密钥安全</span></div>
          </div>

        </div>

        <p>通道加密中采用了哪些加密算法？</p>

        <div>
          <p>一、通道加密</p>
          <p>通道加密中使用到的 RSA, ECDHE, AES256_CBC, SHA256, SHA1等等(如下图)。</p>
          <img src="@/img/pc/td.png" alt="">
          <p>
            步骤:<br>
            1. 客户端和服务器先产生随机数<br>
            2. 服务器下发随机数。<br>
            3. 客户端用 RSA 对客户端随机数进行加密，并发送给服务器。<br>
            4. 服务器用 RSA 解密客户端随机数（使用 RSA 的目的是防止中间人攻击）。<br>
            5. 客户端，服务器用自己的随机数加上对方的随机数生成临时密钥 TempKey 和临时偏移量 TempIV (此时双方均持有相同的 TempKey和TempIV)。<br>
            6. 客户端服务器均使用 ECDHE 生成各自的公私钥对。<br>
            7. 客户端用 TempKey, TempIV 对自己的 ECDHE 公钥进行加密，并将密文发送给服务器。<br>
            8. 服务器收到客户端的 ECDHE 公钥密文，并解密。<br>
            9. 服务器使用 TempKey, TempIV 对自己的 ECDHE 公钥进行加密，并使用 RSA 对 ECDHE。<br>
            10. 服务器使用 ECDHE 算法，使用客户端 ECDHE 公钥明文+服务器 ECDHE 私钥明文生成ShareKey。<br>
            11. 客户端收到服务器的 ECDHE 公钥密文和签名，然后进行解密和验证签名，如果没有问题，就使用客户端 ECDHE 私钥明文+服务器ECDHE 公钥明文生成 ShareKey。<br>
            12. 服务器初始化各个参数，下发给客户端,参数包含：<br>
            • AuthKeyID： 服务器随机生成的客户端临时标识符<br>
            • MsgKey： 由 ShareKey, AuthkeyID, MsgID, SessionID, Salt, SeqNo 以及真实的消息内容相加后进行 Sha256 后的值<br>
            本参数用于：<br>
            a. 进行防止数据篡改的验证<br>
            b. 与 ShareKey 一起使用，生成 Aes256 key, IV，用来对各条消息进行加密。<br>
            • MsgID：时间相关的消息 ID，用于防止重放和去重。<br>
            • SessionID：每次登录唯一的会话 ID。<br>
            • Salt：每次登录唯一的盐值。<br>
            • SeqNo：用于防止重放。<br>
            13. 后续每条消息均会有不同的 MsgID, SessionID, Salt, SeqNo 和真实的消息内容；这些变化的值会导致 MsgKey 每次都不同。 这个每次都 不同的 MsgKey 加上 ShareKey
            可以为每一条消息生成对应的 32 字节密钥和偏移量。<br>
            14. ShareKey 会过期，过期后需要重新进行密钥协商。
          </p>
        </div>


        <div>
          <p>二、内容加密详解</p>
          <img src="@/img/pc/Frame 1010104364@2x.png" alt="">
          <p>
            1. 用户生成 ECDHE 公私钥，保存在本地。<br>
            2. 将公钥发送到服务器，私钥保存在本地。<br>
            3. 用户登录，获取所有好友信息的更新，包含每个好友的公钥。<br>
            4. 发送消息，和接收消息时均采用自己的私钥+对方的公钥生成 ShareKey。<br>
            5. 使用 ShareKey 生成 AES256 的密钥，进行加密和解密。<br>
          </p>
        </div>



        <div>
          <p>三、服务器数据库安全</p>
          <img src="@/img/pc/Frame 1010104364@2x (1).png" alt="">
          <p>
            1. 数据库有签名字段。<br>
            2. 服务器上生成 ECDSA 公私钥。<br>
            3. 服务器代码中对数据库敏感字段，比如：password, userID, friend 等做增删改操作时均通过 ECDSA 生成签名，并更新到签名字段。<br>
            4. 服务器代码对 password, userID, friend 等数据进行读取，判断等操作时进行 ECDSA验证签名，只有通过验证才能进行后续流程，否则 给客户端报错。<br>
            5. 服务端程序进行加密和签名保护。
          </p>
        </div>



        <div>
          <p>四、 密钥安全</p>
          <p>1. 用户的登录密码，二次密码，自动登录密码，均采用 SRP 算法，服务器上不存储用户的密码。<br>
            2. 用户的加密私钥仅放在用户手机。<br>
            3. 用户可随时在客户端上手动更新内容加密的密钥。<br>
          </p>
          <p>什么是公钥和私钥？</p>
          <p>公开密钥（PubKey:简称公钥）和私有密钥（PriKey:简称私钥）。公钥与私钥是一对，如果用公钥对数据进行加密，只有用对应的私钥才能解密。
            因为加密和解密使用的是两个不同的密钥，所以这种算法叫作非对称加密算法。如上文加密中使用的RSA、ECDHE为非对称加密算法</p>
          <p>非对称加密工作原理？</p>
          <p>
            1、A要向B发送信息，A和B都要产生一对用于加密和解密的公钥和私钥。<br>
            2、A的私钥保密，A的公钥告诉B；B的私钥保密，B的公钥告诉A。<br>
            3、A要给B发送信息时，A用B的公钥加密信息，因为A知道B的公钥。<br>
            4、A将这个消息发给B（已经用B的公钥加密消息）。<br>
            5、B收到这个消息后，B用自己的私钥解密A的消息。其他所有收到这个数据的人都无法解密，因为只有B才有B的私钥。
          </p>
        </div>




      </div>

      <div class="pc-menu1" v-show="menuIndex==1">

        <div class="pc-menu1-1" v-show="!showDetailZp">

          <div v-for="item in dynamicNewsDataZp" :key="item.id" @click="clickDynamicNewsDataZp(0,item)">
            <p>{{item.title}}</p>
            <div v-html="item.content"></div>
            <p>{{timestampToTime(item.createTime/1000)}} 来源：{{item.subtitle}}</p>
          </div>
        </div>


        <div class="pc-menu1-2" v-show="showDetailZp">
          <p><span @click="clickDynamicNewsDataZp(1,null)" style="cursor: pointer;">网络诈骗专题></span><span
              style="color: #4371FF;">{{detailDataZp.title}}</span></p>
          <p>{{detailDataZp.title}}</p>
          <p>{{timestampToTime(detailDataZp.createTime/1000)}} 来源：{{detailDataZp.subtitle}}</p>
          <div v-html="detailDataZp.content"></div>
        </div>



      </div>


      <div class="pc-menu2" v-show="menuIndex==2">

        <div class="pc-menu2-1" v-show="!showDetailHy">

          <div v-for="item in dynamicNewsDataHy" :key="item.id" @click="clickDynamicNewsDataHy(0,item)">
            <p>{{item.title}}</p>
            <div v-html="item.content"></div>
            <p>{{timestampToTime(item.createTime/1000)}} 来源：{{item.subtitle}}</p>
          </div>
        </div>


        <div class="pc-menu2-2" v-show="showDetailHy">
          <p><span @click="clickDynamicNewsDataHy(1,null)" style="cursor: pointer;">行业相关></span><span
              style="color: #4371FF;">{{detailDataHy.title}}</span></p>
          <p>{{detailDataHy.title}}</p>
          <p>{{timestampToTime(detailDataHy.createTime/1000)}} 来源：{{detailDataHy.subtitle}}</p>
          <div v-html="detailDataHy.content"></div>
        </div>


      </div>




    </div>


    <bottom></bottom>
    <down></down>
  </div>

</template>

<script>
  import api from "@/api/api";
  import request from '@/api/request';
  import headr from '@/components/head/index'
  import bottom from '@/components/bottom/index'
  import down from '@/components/down/index'
  import {
    Notify
  } from 'vant';
  import {
    Dialog
  } from 'vant';
  export default {
    components: {
      headr,
      bottom,
      down
    },
    data() {
      return {
        menuIndex: 0,
        jmInfoIndex: 0,
        menuYes: 'border-bottom: 4px solid #4371FF;color: #4371FF;height: 26px;',
        menuNo: 'border-bottom: 0px;color: #666666;height: 26px;',

        jmInfoIndexYes: 'border-bottom: 2px solid #4371FF;color: #4371FF;',
        jmInfoIndexNo: 'border-bottom: 2px solid #E0E0E0;color: #666666;',
        dynamicNewsDataZp: undefined,
        showDetailZp: false,
        detailDataZp: {},
        dynamicNewsDataHy: undefined,
        showDetailHy: false,
        detailDataHy: {},

      }
    },
    created() {

    },
    computed: {

    },
    mounted() {


    },

    destroyed() {

    },
    methods: {
      clickDynamicNewsDataZp(type, item) {
        console.log(type)
        if (type == 0) {
          this.showDetailZp = true;
          this.detailDataZp = item
        } else {
          this.showDetailZp = false;
          this.detailDataZp = {}
        }


      },
      clickDynamicNewsDataHy(type, item) {
        console.log(type)
        if (type == 0) {
          this.showDetailHy = true;
          this.detailDataHy = item
        } else {
          this.showDetailHy = false;
          this.detailDataHy = {}
        }


      },
      timestampToTime(timestamp) {
        var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
        var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() + ':' : date.getSeconds() + '';
        return Y + M + D;
      },
      getDynamic(type) {
        var that = this;
        request.getWay(
          api.apiConfig.getDynamic, {
            displayLocation: type
          },
          function (response) {
            if (type == 1)
              that.dynamicNewsDataZp = response.data;
            if (type == 2)
              that.dynamicNewsDataHy = response.data;

          }
        );





      },
      onclickJxInfo(key) {

        this.jmInfoIndex = key

        // if (key == "menu1")
        //   this.$router.push({
        //     name: 'index'
        //   });
        // if (key == "menu2")
        //   this.$router.push({
        //     name: 'security'
        //   });
        // if (key == "menu3")
        //   this.$router.push({
        //     name: 'index'
        //   });



      },


      onclick(key) {

        this.menuIndex = key

        if (key == 1 && this.dynamicNewsDataZp == undefined)
          this.getDynamic(key)
        if (key == 2 && this.dynamicNewsDataHy == undefined)
          this.getDynamic(key)
        // if (key == "menu1")
        //   this.$router.push({
        //     name: 'index'
        //   });
        // if (key == "menu2")
        //   this.$router.push({
        //     name: 'security'
        //   });
        // if (key == "menu3")
        //   this.$router.push({
        //     name: 'index'
        //   });



      },

    }
  }

</script>

//pc端
<style scoped>
  /* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
  @media (min-width: 768px) {

    #mobile {
      display: none;
    }

    #pc {
      margin-right: 168px;
      margin-left: 168px;
    }

    .menu {
      display: flex;
      flex-flow: row;
      align-items: center;
      margin-top: 80px;
      margin-bottom: 52px;
    }

    .menu>div {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 80px;
    }

    .pc-menu0 {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
    }

    .pc-menu0>p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 0;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(2) {
      width: 1544px;
      height: 120px;
      background: #F9F9F9;
      margin-top: 24px;
      margin-bottom: 40px;
      padding-left: 20px;
    }

    .pc-menu0>div:nth-child(2)>p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .pc-menu0>div:nth-child(2)>div {
      display: flex;
      flex-flow: row;
      align-items: center;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .pc-menu0>div:nth-child(2)>div>div {
      margin-right: 15px;
    }

    .pcLable {
      color: #4371FF;
      margin-right: 5px;
    }

    .jmInfo {
      width: 100%;
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;
      margin-bottom: 56px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #666666;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;


    }

    .jmInfo>div {
      width: 300px;
      height: 44px;

    }

    .pc-jmInfo0 {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
    }

    .pc-jmInfo0>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 0;
      margin-bottom: 0;
    }

    .pc-jmInfo0>div:nth-child(2) {
      width: 100%;

      height: 1008px;
      ;
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      align-items: flex-start;


      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 16px;
      margin-bottom: 0;
    }

    .pc-jmInfo0>div:nth-child(2)>div:first-child {
      width: 732px;
      height: 908px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }

    .pc-jmInfo0>div:nth-child(2)>div:first-child>p {
      margin-top: 0px;
      margin-bottom: 12px;

    }

    .pc-jmInfo0>div:nth-child(2)>div:last-child>img {
      width: 732px;
      height: 908px;

    }



    .pc-jmInfo0>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 80px;
      margin-bottom: 0;
    }

    .pc-jmInfo0>div:nth-child(4) {
      width: 1544px;
      height: 120px;
      background: #F9F9F9;
      border-radius: 0px 0px 0px 0px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 24px;
      margin-bottom: 0;
      padding-right: 20px;
      padding-left: 20px;
    }

    .pc-jmInfo0>p:nth-child(5) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 44px;
      margin-bottom: 0;
    }


    .pc-jmInfo0>div:nth-child(6) {
      width: 1544px;
      height: 204px;
      background: #F9F9F9;
      border-radius: 0px 0px 0px 0px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 24px;
      margin-bottom: 202px;
      padding-right: 20px;
      padding-left: 20px;

    }

    .pc-jmInfo0>div:nth-child(6)>p {

      margin-top: 12px;
      margin-bottom: 0px;
    }

    .pc-jmInfo1 {
      width: 100%;
    }

    .pc-jmInfo1>div:first-child {

      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: space-between;
    }

    .pc-jmInfo1>div:first-child>div:first-child {
      display: flex;
      flex-flow: column;
      align-items: flex-start;

      width: 706px;
      height: 1140px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.09);
      border-radius: 8px 8px 8px 8px;

      padding-right: 32px;
      padding-left: 32px;

    }

    .pc-jmInfo1>div:first-child>div:first-child>p:first-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 32px;
      margin-bottom: 20px;
    }

    .pc-jmInfo1>div:first-child>div:first-child>div:nth-child(2) {
      width: 646px;
      height: 180px;
      background: #F9F9F9;
      border-radius: 4px 4px 4px 4px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      padding-left: 20px;

    }

    .pc-jmInfo1>div:first-child>div:first-child>div:nth-child(2)>p {
      margin-top: 7px;
      margin-bottom: 0px;

    }



    .pc-jmInfo1>div:first-child>div:first-child>img {
      width: 706px;
      height: 822px;
      margin-top: 20px;
      margin-bottom: 32px;

    }




    .pc-jmInfo1>div:first-child>div:last-child {
      display: flex;
      flex-flow: column;
      align-items: flex-start;

      width: 706px;
      height: 1140px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.09);
      border-radius: 8px 8px 8px 8px;

      padding-right: 32px;
      padding-left: 32px;

    }

    .pc-jmInfo1>div:first-child>div:last-child>p:first-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 32px;
      margin-bottom: 20px;
    }

    .pc-jmInfo1>div:first-child>div:last-child>div:nth-child(2) {
      width: 626px;
      height: 124px;
      background: #F9F9F9;
      border-radius: 4px 4px 4px 4px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      padding-left: 20px;
      padding-right: 20px;

    }

    .pc-jmInfo1>div:first-child>div:last-child>div:nth-child(2)>p {
      margin-top: 16px;
      margin-bottom: 0px;

    }



    .pc-jmInfo1>div:first-child>div:last-child>img {
      width: 706px;
      height: 878px;
      margin-top: 20px;
      margin-bottom: 32px;

    }

    .pc-jmInfo1>p:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 44px;
      margin-bottom: 0px;

    }

    .pc-jmInfo1>div:nth-child(3) {
      width: 1544px;
      height: 100px;
      background: #F9F9F9;
      padding-top: 32px;
      padding-right: 20px;
      padding-left: 20px;
      margin-top: 24px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }


    .pc-jmInfo1>p:nth-child(4) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 44px;
      margin-bottom: 0px;

    }

    .pc-jmInfo1>div:nth-child(5) {
      width: 1544px;
      height: 204px;
      background: #F9F9F9;
      padding-top: 32px;
      padding-right: 20px;
      padding-left: 20px;
      margin-top: 24px;
      margin-bottom: 127px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }

    .pc-jmInfo1>div:nth-child(5)>p {

      margin-top: 0px;
      margin-bottom: 10px;


    }


    .pc-jmInfo2 {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
    }

    .pc-jmInfo2>p:first-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 0;
      margin-bottom: 0;
    }

    .pc-jmInfo2>div:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 16px;
      margin-bottom: 0;

    }

    .pc-jmInfo2>div:nth-child(2)>p {
      margin-top: 10px;
      margin-bottom: 0;

    }



    .pc-jmInfo2>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 80px;
      margin-bottom: 0;
    }

    .pc-jmInfo2>div:nth-child(4) {
      width: 1544px;
      height: 100px;
      padding-left: 20px;
      padding-right: 20px;
      background: #F9F9F9;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 24px;
      margin-bottom: 0;

    }


    .pc-jmInfo2>p:nth-child(5) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 44px;
      margin-bottom: 0;
    }

    .pc-jmInfo2>div:nth-child(6) {
      width: 1544px;
      height: 204px;
      padding-left: 20px;
      padding-right: 20px;
      background: #F9F9F9;
      margin-bottom: 112px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 24px;

    }

    .pc-jmInfo2>div:nth-child(6)>p {
      margin-top: 25px;
      margin-bottom: 0px;
    }







    .pc-jmInfo3 {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
    }

    .pc-jmInfo3>p:first-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 0;
      margin-bottom: 0;
    }

    .pc-jmInfo3>div:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 16px;
      margin-bottom: 0;

    }

    .pc-jmInfo3>div:nth-child(2)>p {
      margin-top: 10px;
      margin-bottom: 0;

    }



    .pc-jmInfo3>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 80px;
      margin-bottom: 0;
    }

    .pc-jmInfo3>div:nth-child(4) {
      width: 1544px;
      height: 100px;
      padding-left: 20px;
      padding-right: 20px;
      background: #F9F9F9;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 24px;
      margin-bottom: 0;

    }


    .pc-jmInfo3>p:nth-child(5) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 44px;
      margin-bottom: 0;
    }

    .pc-jmInfo3>div:nth-child(6) {
      width: 1544px;
      height: 204px;
      padding-left: 20px;
      padding-right: 20px;
      background: #F9F9F9;
      margin-bottom: 112px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 24px;

    }

    .pc-jmInfo3>div:nth-child(6)>p {
      margin-top: 25px;
      margin-bottom: 0px;
    }

    .pc-menu1-1 {
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-bottom: 25px;
      min-height: 400px;
    }

    .pc-menu1-1>div {
      width: 324px;
      height: 160px;
      padding: 24px 24px 24px 24px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.09);
      border-radius: 12px 12px 12px 12px;
      margin-right: 16px;
      margin-bottom: 32px;
    }

    .pc-menu1-1>div>p:nth-child(1) {
      width: 254px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 0;
      margin-bottom: 0;

      white-space: nowrap;
      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 使用省略号表示溢出的文本 */

    }





    .pc-menu1-1>div>div:nth-child(2) {
      width: 324px;
      height: 84px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;

      overflow: hidden;
      text-overflow: ellipsis;
       /* display: -webkit-box; */ 
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;

    }

    .pc-menu1-1>div>div:nth-child(2)>>>p {

      margin-top: 0;
      margin-bottom: 0;



    }

    .pc-menu1-1>div>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 22px;
      margin-bottom: 0;

      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 使用省略号表示溢出的文本 */

    }

    .pc-menu1-2>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 0;
    }

    .pc-menu1-2>p:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 44px;
      margin-bottom: 0;
    }

    .pc-menu1-2>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;
    }

    .pc-menu1-2>div:nth-child(4) {

      margin-top: 44px;
      margin-bottom: 121px;
    }

    .pc-menu1-2>>>img {

width: 100%;
    }







    .pc-menu2-1 {
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-bottom: 25px;
      min-height: 400px;
    }

    .pc-menu2-1>div {
      width: 324px;
      height: 160px;
      padding: 24px 24px 24px 24px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.09);
      border-radius: 12px 12px 12px 12px;
      margin-right: 16px;
      margin-bottom: 32px;
    }

    .pc-menu2-1>div>p:nth-child(1) {
      width: 254px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 0;
      margin-bottom: 0;

      white-space: nowrap;
      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 使用省略号表示溢出的文本 */

    }





    .pc-menu2-1>div>div:nth-child(2) {
      width: 324px;
      height: 84px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;

      overflow: hidden;
      text-overflow: ellipsis;
      /* display: -webkit-box; */
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;

    }

    .pc-menu2-1>div>div:nth-child(2)>>>p {

      margin-top: 0;
      margin-bottom: 0;



    }

    .pc-menu2-1>div>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 22px;
      margin-bottom: 0;

      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 使用省略号表示溢出的文本 */

    }

    .pc-menu2-2>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 0;
    }

    .pc-menu2-2>p:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 44px;
      margin-bottom: 0;
    }

    .pc-menu2-2>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;
    }

    .pc-menu2-2>div:nth-child(4) {

      margin-top: 44px;
      margin-bottom: 121px;
    }



  }

</style>

//移动端
<style scoped>
  /* 当屏幕宽度小于或等于768像素时，应用以下样式 */
  @media (max-width: 768px) {
    #pc {
      display: none;
    }

    #mobile {
      margin-right: 16px;
      margin-left: 16px;
    }

    .menu {
      display: flex;
      flex-flow: row;
      align-items: center;
      margin-top: 65px;
      margin-bottom: 24px;
    }

    .menu>div {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 32px;
    }



    .pc-menu0 {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
    }

    .pc-menu0>p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 0;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(2) {
      width: 331px;
      height: 73px;
      background: #F9F9F9;
      border-radius: 0px 0px 0px 0px;
      margin-top: 16px;
      margin-bottom: 12px;
      padding-left: 12px;
    }

    .pc-menu0>div:nth-child(2)>p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .pc-menu0>div:nth-child(2)>div {
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: space-between;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .pc-menu0>div:nth-child(2)>div>div {
      margin-right: 10px;
    }

    .pcLable {
      color: #4371FF;
      margin-right: 5px;
    }

    .pc-menu0>div:nth-child(4) {
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
      align-items: flex-start;
    }

    .pc-menu0>div:nth-child(4)>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #4371FF;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 8px;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(4)>p:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 8px;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(4)>img {
      width: 343px;
      height: 425px;
      margin-top: 12px;
    }

    .pc-menu0>div:nth-child(4)>p:nth-child(4) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;
    }




    .pc-menu0>div:nth-child(5) {
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
      align-items: flex-start;
    }

    .pc-menu0>div:nth-child(5)>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #4371FF;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 8px;
      margin-bottom: 0;
    }


    .pc-menu0>div:nth-child(5)>img {
      width: 343px;
      height: 330px;
      margin-top: 12px;
    }

    .pc-menu0>div:nth-child(5)>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;
    }



    .pc-menu0>div:nth-child(6) {
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
      align-items: flex-start;
    }

    .pc-menu0>div:nth-child(6)>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #4371FF;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 8px;
      margin-bottom: 0;
    }


    .pc-menu0>div:nth-child(6)>img {
      width: 343px;
      height: 426px;
      margin-top: 12px;
    }

    .pc-menu0>div:nth-child(6)>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(7) {
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
      align-items: flex-start;
    }

    .pc-menu0>div:nth-child(7)>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #4371FF;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 8px;
      margin-bottom: 0;
    }


    .pc-menu0>div:nth-child(7)>p:nth-child(2) {
      width: 343px;
      height: 88px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(7)>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 24px;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(7)>p:nth-child(4) {
      width: 319px;
      height: 85px;
      background: #F9F9F9;
      border-radius: 0px 0px 0px 0px;
      padding: 12px 12px 12px 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      text-transform: none;


      margin-top: 24px;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(7)>p:nth-child(5) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 24px;
      margin-bottom: 0;
    }

    .pc-menu0>div:nth-child(7)>p:nth-child(6) {
      width: 319px;
      height: 170px;
      background: #F9F9F9;
      border-radius: 0px 0px 0px 0px;
      padding: 12px 12px 12px 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      text-transform: none;


      margin-top: 24px;
      margin-bottom: 29px;
    }

    .pc-menu1-1 {
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 25px;
      min-height: 200px;

    }

    .pc-menu1-1>div {
      width: 311px;
      height: 116px;
      background: #FFFFFF;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
      border-radius: 4px 4px 4px 4px;

      padding: 16px 16px 16px 16px;
      margin-bottom: 12px;
    }

    .pc-menu1-1>div>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 0;
      margin-bottom: 8px;
      
      white-space: nowrap;
      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 使用省略号表示溢出的文本 */

    }





    .pc-menu1-1>div>div:nth-child(2) {
      width: 311px;
      height: 63px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;


      overflow: hidden;
      text-overflow: ellipsis;
      /* display: -webkit-box; */
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;

    }

    .pc-menu1-1>div>div:nth-child(2)>>>p {

      margin-top: 0;
      margin-bottom: 0;



    }

    .pc-menu1-1>div>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;

      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 使用省略号表示溢出的文本 */

    }

    .pc-menu1-2>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 0;
    }

    .pc-menu1-2>p:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 20px;
      margin-bottom: 0;
    }

    .pc-menu1-2>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;
    }

    .pc-menu1-2>div:nth-child(4) {

      margin-top: 24px;
      margin-bottom: 30px;
    }

    .pc-menu1-2>>>img {

  width: 100%;
    }







       .pc-menu2-1 {
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 25px;
      min-height: 200px;

    }

    .pc-menu2-1>div {
      width: 311px;
      height: 116px;
      background: #FFFFFF;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
      border-radius: 4px 4px 4px 4px;

      padding: 16px 16px 16px 16px;
      margin-bottom: 12px;
    }

    .pc-menu2-1>div>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-top: 0;
      margin-bottom: 8px;
      
      white-space: nowrap;
      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 使用省略号表示溢出的文本 */

    }





    .pc-menu2-1>div>div:nth-child(2) {
      width: 311px;
      height: 63px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      overflow: hidden;
      text-overflow: ellipsis;
      /* display: -webkit-box; */
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;

    }

    .pc-menu2-1>div>div:nth-child(2)>>>p {

      margin-top: 0;
      margin-bottom: 0;



    }


    .pc-menu2-1>div>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;

      overflow: hidden;
      /* 隐藏溢出的内容 */
      text-overflow: ellipsis;
      /* 使用省略号表示溢出的文本 */

    }

    .pc-menu2-2>p:nth-child(1) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 0;
    }

    .pc-menu2-2>p:nth-child(2) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 20px;
      margin-bottom: 0;
    }

    .pc-menu2-2>p:nth-child(3) {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 12px;
      margin-bottom: 0;
    }

    .pc-menu2-2>div:nth-child(4) {

      margin-top: 24px;
      margin-bottom: 30px;
    }

  

  }

</style>



// WEBPACK FOOTER //
// src/view/security/index.vue